import React, { Component } from "react";
import { Fragment } from "react";
import "./education.css";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import { getEducations } from "../../constants/education-constants";
import EducationElement from "./educationElement";
export default class education extends Component {

    state = {
        educations: []
    };

    componentDidMount() {
        const educations = [...getEducations()];
        this.setState({ educations });
    }

    render() {
        return (
            <Fragment>
                <Header />
                <section className="container education-list">
                    <div className="row">
                        <section>
                            {this.state.educations.map(element => (
                                <EducationElement
                                    key={element.key}
                                    id={element.id}
                                    title={element.title}
                                    description={element.description}
                                    price={element.price}
                                    location={element.location}
                                    imageUrl={element.imageUrl}
                                />
                            ))}
                        </section>
                    </div>
                </section>
                <Footer />
            </Fragment>
        );
    }
}
